import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from "../components/custom/HomeView";
import Instructions from "@/components/custom/Instructions";
import LoginView from "../components/login/LoginView";
import InfoView from "../views/Info";
import Print from "../views/Print";
import PrintParent from "@/views/PrintParent";

import StudentIndexView from "../components/student/StudentIndexView";
import EmployeeIndexView from "../components/employee/EmployeeIndexView";
import SchoolIndexView from "../components/school/SchoolIndexView";
import SingleStudentIndexView from "../components/student/SingleStudentIndexView";
import SingleSchoolIndexView from "../components/school/SingleSchoolIndexView";
import SingleEmployeeIndexView from "../components/employee/SingleEmployeeIndexView";
import IndexView from "../components/index/IndexView";
import RoleIndexView from "../components/index/RoleIndexView";
import PermissionIndexView from "../components/index/PermissionIndexView";
import UserIndexView from "../components/index/UserIndexView";
import CountyCoordinatorView from "@/components/reports/CountyCoordinatorView";
import SUMITCoordinatorView from "@/components/reports/SUMITCoordinatorView";
import WorkshopReports from "@/components/reports/WorkshopReports";
import TeacherSubjects from "@/components/reports/TeacherSubjects";
import eduIDReports from "@/components/reports/eduIDReports";
import SchoolPlansReport from "@/components/reports/SchoolPlansReport";
import TeachersInCanton from "@/components/reports/TeachersInCanton.vue";
import TeachersInCantonForSchoolYear from "@/components/reports/TeachersInCantonForSchoolYear.vue";
import StudentsInCantonForSchoolYear from "@/components/reports/StudentsInCantonForSchoolYear.vue";
import StudentsInSchool from "@/components/reports/StudentsInSchool.vue";

import DepartmentIndexView from "@/components/department/DepartmentIndexView";
import SingleDepartmentIndexView from "@/components/department/SingleDepartmentIndexView";
import EditDepartmentStudents from "@/components/department/departmentInfo/departmentStudents/EditDepartmentStudents";
import StudentDetailsIndex from "@/components/department/departmentInfo/studentDetails/StudentDetailsIndex";
import CantonIndexView from "@/components/canton/CantonIndexView";
import DiplomaIndex from "@/components/diploma/DiplomaIndex";

import SubjectIndexView from "../components/subjects/SubjectIndexView";
import AddSubject from "../components/subjects/AddSubject";
import EditSubject from "../components/subjects/EditSubject";
import PlanIndexView from "../components/plans/PlanIndexView";
import SinglePlanIndexView from "../components/plans/SinglePlanIndexView";
import EditPlan from "../components/plans/EditPlan";
import AddPlan from "../components/plans/AddPlan";
import FieldView from "../components/fields/FieldView";
import MySchool from "../components/myschool/MySchool";
import DemandIndex from "../components/demand/DemandIndex";
import StudentLearning from "../components/reports/StudentLearning";
import StudentConduct from "../components/reports/StudentConduct";
import AverageBySubjects from "../components/reports/AverageBySubjects";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'LoginView',
        component: LoginView
    },

    {
        path: '/admin',
        name: 'HomeView',
        component: HomeView
    },

    {
        path: '/admin/upute',
        name: 'Instructions',
        component: Instructions
    },

    {
        path: '/admin/print',
        name: 'Print',
        component: Print
    },
    {
        path: '/admin/print_parent',
        name: 'PrintParent',
        component: PrintParent
    },
    {
        path: '/admin/zahtjev',
        component: DemandIndex,
        name: 'DemandIndex'
    },

    {
        path: '/info',
        name: 'Info',
        component: InfoView,
    },

    {
        path: '/uvjerenje/:uvjerenje_id',
        component: DiplomaIndex,
        name: 'DiplomaIndex',
    },

    {
        path: '/admin/ucenik',
        component: StudentIndexView,
        name: 'StudentTableView',
    },

    {
        path: '/admin/skola',
        component: SchoolIndexView,
        name: 'SchoolTableView',
    },

    {
        path: '/admin/zupanija',
        component: CantonIndexView,
        name: 'CantonTableView',
    },

    {
        path: '/admin/zupanija/add/:resource_id?',
        component: CantonIndexView,
        name: 'CantonAddView',
    },

    {
        path: '/admin/djelatnik',
        component: EmployeeIndexView,
        name: 'EmployeeTableView',
    },

    {
        path: '/admin/odjeljenje',
        component: DepartmentIndexView,
        name: 'DepartmentTableView',
    },

    {
        path: '/admin/odjeljenje/dodaj/:resource_id?',
        component: DepartmentIndexView,
        name: 'DepartmentAddView',
    },

    {
        path: '/admin/odjeljenje/pregled/:odjeljenje_id',
        component: SingleDepartmentIndexView,
        name: 'SingleDepartment',
    },
    {
        path: '/admin/odjeljenje/pregled/:odjeljenje_id/ucenik/dodaj',
        component: EditDepartmentStudents,
        name: 'EditDepartmentStudents',
    },
    {
        path: '/admin/odjeljenje/pregled/:odjeljenje_id/ucenik/:ucenik_id',
        component: StudentDetailsIndex,
        name: 'StudentDetailsIndex',
    },
    {
        path: '/admin/ucenik/pregled/:ucenik_id',
        component: SingleStudentIndexView,
        name: 'SingleStudentTableView',
    },
    {
        path: '/admin/skola/pregled/:skola_id',
        component: SingleSchoolIndexView,
        name: 'SingleSchoolTableView',
    },
    {
        path: '/admin/djelatnik/pregled/:djelatnik_id',
        component: SingleEmployeeIndexView,
        name: 'SingleEmployeeTableView',
    },
    {
        path: '/admin/predmeti',
        component: SubjectIndexView,
        name: 'SubjectIndexView',
    },
    {
        path: '/admin/predmeti/dodaj',
        component: AddSubject,
        name: 'AddSubject',
    },
    {
        path: '/admin/predmeti/:id/uređivanje',
        component: EditSubject,
        name: 'EditSubject',
    },
    {
        path: '/admin/nastavni_planovi',
        component: PlanIndexView,
        name: 'PlanIndexView',
    },
    {
        path: '/admin/nastavni_planovi/dodaj_plan',
        component: AddPlan,
        name: 'AddPlan',
    },
    {
        path: '/admin/nastavni_planovi/:id',
        component: SinglePlanIndexView,
        name: 'SinglePlanIndexView',
    },
    {
        path: '/admin/nastavni_planovi/:id/uređivanje',
        component: EditPlan,
        name: 'EditPlan',
    },
    {
        path: '/admin/smjerovi',
        component: FieldView,
        name: 'FieldView',
    },
    {
        path: '/admin/moja_skola',
        component: MySchool,
        name: 'MySchool',
    },
    {
        path: '/admin/:table',
        component: IndexView,
        name: 'TableView',
    },
    {
        path: '/admin/izvjestaj/zupanijski_koordinatori',
        component: CountyCoordinatorView,
        name: 'CountyCoordinatorView',
    },
    {
        path: '/admin/izvjestaj/sumit_koordinatori',
        component: SUMITCoordinatorView,
        name: 'SUMITCoordinatorView',
    },
    {
        path: '/admin/izvjestaj/djelatnici_radionice',
        component: WorkshopReports,
        name: 'WorkshopReports',
    },
    {
        path: '/admin/izvjestaj/nastavnici_predmeti',
        component: TeacherSubjects,
        name: 'TeacherSubjects',
    },
    {
        path: '/admin/izvjestaj/ucenici_ucenje',
        component: StudentLearning,
        name: 'StudentLearning',
    },
    {
        path: '/admin/izvjestaj/ucenici_vladanje',
        component: StudentConduct,
        name: 'StudentConduct',
    },
    {
        path: '/admin/izvjestaj/ostvarenje_plana',
        component: AverageBySubjects,
        name: 'AverageBySubjects',
    },
    {
        path: '/admin/izvjestaj/dodjeljeni_eduid',
        component: eduIDReports,
        name: 'eduIDReports',
    },
    {
        path: '/admin/izvjestaj/izvjestaji_skolski_planovi',
        component: SchoolPlansReport,
        name: 'SchoolPlansReport',
    },
    {
        path: '/admin/izvjestaj/profesori_po_zupanijama',
        component: TeachersInCanton,
        name: 'TeachersInCanton',
    },
    {
        path: '/admin/izvjestaj/profesori_po_zupanijama_popis',
        component: TeachersInCantonForSchoolYear,
        name: 'TeachersInCantonForSchoolYear',
    },
    {
        path: '/admin/izvjestaj/studenti_po_zupanijama_popis',
        component: StudentsInCantonForSchoolYear,
        name: 'StudentsInCantonForSchoolYear',
    }, {
        path: '/admin/izvjestaj/studenti_skolama_popis',
        component: StudentsInSchool,
        name: 'StudentsInSchool',
    },
    {
        path: '/admin/djelatnik/add/:resource_id?',
        component: EmployeeIndexView,
        name: 'EmployeeAddView',
    },
    {
        path: '/admin/ucenik/add/:resource_id?',
        component: StudentIndexView,
        name: 'StudentAddView',
    },
    {
        path: '/admin/odjeljenje/pregled/:odjeljenje_id/ucenik/:ucenik_id/dokumenti',
        component: StudentIndexView,
        name: 'StudentDocumentsView',
    },

    {
        path: '/admin/:table/add/:resource_id?',
        component: IndexView,
        name: 'AddView',
    },
    {
        path: '/admin/pregled/korisnik',
        component: UserIndexView,
        name: 'UserTableView',
    },
    {
        path: '/admin/pregled/korisnik/add/:resource_id?',
        component: UserIndexView,
        name: 'UserAddView',
    },
    {
        path: '/admin/pregled/uloga',
        component: RoleIndexView,
        name: 'RoleIndexView',
    },
    {
        path: '/admin/pregled/dozvola',
        component: PermissionIndexView,
        name: 'PermissionIndexView',
    },

    /*
    {
        path: '/pregled/dozvola',
        component: PermissionIndexView,
        name: 'PermissionIndexView',
    },
{
  path: '/about',
  name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" // '../views/About.vue')
}*/
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
